import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  base_url,Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {

  MenuItem,

} from '@mui/material';

const QuantityStockFollowUp = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  // const [dataa, setDataa] = useState([]);
  const [datagroupby, setDatagroupby] = useState([]);
  const [datagroupbyConsumblesection, setDatagroupbyConsumblesection] = useState([]);
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(458)); 
        console.log(permission);
      let para ={season_id:season_id};
      axios.post("/quality-stock-follow-ups/listing",para,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setData(response.data.data.stocks);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });


      axios.post("/quality-stock-follow-ups/listing-groupby-comsumble-location",para,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setDatagroupby(response.data.data.stocks_groupby);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
      axios.post("/quality-stock-follow-ups/listing-groupby-consumable-section-location",para,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setDatagroupbyConsumblesection(response.data.data.stocks_groupby_suppliers);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  
  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
          let season_id = localStorage.getItem("season_id");
         axios.get(`/quality-stock-follow-ups/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/quality-stock-situations";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }
  
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



// ✅ Reusable Link Cell Component - Consumable
const ConsumableLinkCell = ({ row }) => {
  const url = `/quality-stock-situations-viewby-consumable-location/${row.original.consomable}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.consumable_product?.consumable_name || ''}
    </a>
  );
};

// ✅ Reusable Link Cell Component - Location
const LocationLinkCell = ({ row }) => {
  const url = `/quality-stock-situations-viewby-consumable-location/${row.original.consomable}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.location_name || ''}
    </a>
  );
};

// ✅ Available Quantity Cell Component
const AvailableQuantityCell = ({ row }) => {
  return (
    <span>
      {row.original.total_in_quantity - row.original.total_out_quantity}
    </span>
  );
};

// ✅ PropTypes Validation
ConsumableLinkCell.propTypes = LocationLinkCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      consumable_name: PropTypes.string,
      location_name: PropTypes.string,
      consomable: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      location: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }).isRequired,
  }).isRequired,
};

AvailableQuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_in_quantity: PropTypes.number.isRequired,
      total_out_quantity: PropTypes.number.isRequired,
      product_out_final_quantity: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};





const AvailableAlertQuantityCell = ({ row }) => {
  const available_qty = 
    (row.original.total_in_quantity - row.original.total_out_quantity );
  
  const critical_level = row.original.consumable_product?.critical_level || 0;

  const average_level = row.original.consumable_product?.average_level || 0;
  let alert_qty = null;
    console.log("average_level");

  console.log(row.original.consumable_product);
   if (available_qty < critical_level) {
    alert_qty = (
      <span style={{ color: 'red', fontWeight: 'bold' }}>
        CRITICAL LEVEL
      </span>
    );
  }else if ( available_qty >= critical_level && available_qty <= average_level) {
    alert_qty = (
      <span style={{ color: 'orange', fontWeight: 'bold' }}>
        AVERAGE LEVEL
      </span>
    );
  } else{
    alert_qty = (
      <span style={{ color: 'orange', fontWeight: 'bold' }}> </span>
    );
  }
  return <div>{alert_qty}</div>;
};
AvailableAlertQuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_in_quantity: PropTypes.number.isRequired,
      total_out_quantity: PropTypes.number.isRequired,
      consumable_product: PropTypes.string,
      product_out_final_quantity: PropTypes.number.isRequired,
      consomable_average_level: PropTypes.number.isRequired,
      consomable_critical_level: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columnsss = [
  {
    header: 'Consumable',
    accessorFn: (row) => row.consumable_product?.consumable_name || '',
    Cell: ConsumableLinkCell,
  },
  {
    header: 'Location',
    accessorFn: (row) => row.location_name,
    Cell: LocationLinkCell,
  },
  {
    header: 'Available Quantity',
    accessorFn: (row) => row.total_in_quantity - row.total_out_quantity,
    Cell: AvailableQuantityCell,
  },

  {
    header: 'Quantity Alert',
    // accessorFn: (row) => {
    //   const available_qty = row.total_in_quantity - row.total_out_quantity;
    //   const critical_level = row.consumable_product?.critical_level || 0;
    //   const average_level = row.consumable_product?.average_level || 0;
      
    //   // Return numeric value for sorting: 0 = critical, 1 = average, 2 = normal
    //   if (available_qty < critical_level) {
    //     return 0; // Critical - highest priority
    //   } else if (available_qty >= critical_level && available_qty <= average_level) {
    //     return 1; // Average - medium priority
    //   } else {
    //     return 2; // Normal - lowest priority
    //   }
    // },
     accessorFn: (row) => {
    const available_qty =
      Number(row.total_in_quantity || 0) - Number(row.total_out_quantity || 0);

    const critical_level = row.consumable_product?.critical_level || 0;
    const average_level = row.consumable_product?.average_level || 0;

    if (available_qty < critical_level) {
      return 'CRITICAL LEVEL';
    } else if (available_qty >= critical_level && available_qty <= average_level) {
      return 'AVERAGE LEVEL';
    } else {
      return 'NORMAL';
    }
  },
    Cell: AvailableAlertQuantityCell,
    sortingFn: 'basic', // Use basic sorting on the numeric values
  },
];


// ✅ Reusable Link Cell Component
const ConsumableLinkCellSupplier = ({ row }) => {
  const url = `/quality-stock-situations-viewby-consumable-section-location/${row.original.section}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.section_name || ''}
    </a>
  );
};

// ✅ Location Link Cell Component
const LocationLinkCellSupplier = ({ row }) => {
  const url = `/quality-stock-situations-viewby-consumable-section-location/${row.original.section}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.location_name || ''}
    </a>
  );
};

// ✅ Available Quantity Cell Component
const AvailableQuantityCellSupplier = ({ row }) => {
  return (
    <span>
      {row.original.total_in_quantity - row.original.total_out_quantity}
    </span>
  );
};

// ✅ PropTypes Validation
ConsumableLinkCellSupplier.propTypes = LocationLinkCellSupplier.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      
      location_name: PropTypes.string,
      section_name: PropTypes.string,
      section: PropTypes.any.isRequired,
      location: PropTypes.any.isRequired,
    }).isRequired,
  }).isRequired,
};

AvailableQuantityCellSupplier.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_in_quantity: PropTypes.number.isRequired,
      total_out_quantity: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columns_consumble_sections = [
  {
    header: 'Section',
    accessorFn: (row) => row.section_name,
    Cell: ConsumableLinkCellSupplier,
  },
  {
    header: 'Location',
    accessorFn: (row) => row.location,
    Cell: LocationLinkCellSupplier,
  },
  {
    header: 'Available Quantity',
    accessorFn: (row) => row.total_in_quantity - row.total_out_quantity,
    Cell: AvailableQuantityCellSupplier,
  },
];


  // ✅ Location Link Cell Component
const LocationLinkCell2 = ({ row }) => {
  const url = `/quality-stock-situations-view/${row.original.id}`;
  return (
    <a href={url} className="">
      {row.original.location_detail?.title || ''}
    </a>
  );
};

// ✅ PropTypes Validation
LocationLinkCell2.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.any.isRequired,
      location_detail: PropTypes.shape({
        title: PropTypes.string,
      }),
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columns = [
  {
    header: 'Location',
    accessorFn: (row) => row.consumable,
    Cell: LocationLinkCell2,
  },
  {
    header: 'Date',
    accessorKey: 'date',
  },
  {
    header: 'Created',
    accessorKey: 'created_at',
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];


 

  const editItem = (item)=>{
    window.location.href = "/quality-stock-situations-edit/"+item;
  }

const downloadExcel = (e) => {
  console.log(e)
  let season_id = localStorage.getItem("season_id");

  window.open(`${base_url}/quality-stock-situations/export-excel?season_id=${season_id}`, '_blank');

}

  
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Quality stock situation</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Quality stock situation</li>
                </ul>
              </div>
              <div className="col-auto">
                <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                  </button> 
                      &nbsp;&nbsp;
                 {permission && permission.add === 1 && (
                    <Link to="/quality-stock-situations-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                )} 
              </div>
            </div>
          </div>
          <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                  {permission && permission.list === 1 && (

                    <div className="card-body" >
                      <ul className="nav nav-tabs nav-tabs-bottom">
                      

                      <li className="nav-item">
                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">Stock Situation Group By Consumable and Location</a>                                  
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-customer" data-bs-toggle="tab"> Stock Situation Group By Section and Location</a>                                   
                      </li> 
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Stock Situation  Listing</a>                                   
                      </li>                    
                      </ul>
                      <div className="tab-content">

                      <div className="tab-pane show active" id="listing-groupby-supplier">
                      <div className="row"   id="listing-followup">
                        <div className="col-sm-12">
                          <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">

                                <MaterialReactTable columns={columnsss} data={datagroupby} 
                                  enableColumnOrdering
                                  enablePinning
                                   initialState={{
                                    sorting: [
                                      {
                                        id: 'Quantity Alert', // Must match the header name
                                        desc: false, // false = ascending (0, 1, 2) so critical shows first
                                      }
                                    ]
                                  }}
                                />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        
                        </div>                                
                        <div className="tab-pane  " id="listing-customer">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={columns_consumble_sections} data={datagroupbyConsumblesection} 
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>                                
                                          
                        <div className="tab-pane  " id="listing-all">
                              <div className="row"   id="listing-followusp">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={columns} data={data} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                            renderRowActionMenuItems={({ row }) => [
                                            permission?.update === 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete === 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                          />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>    
                      </div>                             
                    </div>
                    )}
                  </div>
              </div>
          </div>
        </div>
               
        </div>
      </div>
    </div>
  );
};
export default QuantityStockFollowUp;
